import { EventConfirmationsActions } from 'src/store/actions/eventConfirmationsActions';
const initialState = {
    loading: false,
    lastConfirmedCount: 0,
    lastWithdrawnCount: 0
};
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case EventConfirmationsActions.CONFIRM_EVENTS_REQUEST: {
            return { ...state, loading: true };
        }
        case EventConfirmationsActions.CONFIRM_EVENTS_SUCCESS: {
            return { ...state, loading: false, lastConfirmedCount: payload?.length ?? 0 };
        }
        case EventConfirmationsActions.WITHDRAW_EVENT_CONFIRMATIONS_SUCCESS: {
            return { ...state, loading: false, lastWithdrawnCount: payload ?? 0 };
        }
        case EventConfirmationsActions.CONFIRM_EVENTS_FAIL: {
            return { ...state, loading: false };
        }
        default:
            return state;
    }
};
